import React from 'react';
import { Progress } from 'antd';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons/faSpinner';
import { getLang } from 'shared/store/selectors/lang.selector';
import { FileRow } from './file-row';
import styles from './uploading-step.module.scss';

const PROGRESS_HEIGHT = 6;

type UploadingStepProps = {
  fileName: string;
  fileSize: number;
  progress: number;
};

export const UploadingStep = ({ fileName, fileSize, progress }: UploadingStepProps) => {
  const lang = useSelector(getLang('SETTINGS'));

  return (
    <div>
      <FileRow fileName={fileName} fileSize={fileSize} />

      <div className={styles.progressCard}>
        <div className={styles.labelRow}>
          <span className={styles.label}>
            <FontAwesomeIcon icon={faSpinner} spin className={styles.spinner} />
            {lang.SHIFTS_IMPORTING}
          </span>
          <span className={styles.label}>{progress}%</span>
        </div>
        <Progress
          percent={progress}
          showInfo={false}
          size={{ height: PROGRESS_HEIGHT }}
          strokeColor="var(--primary)"
          trailColor="var(--primary-light)"
        />
      </div>
    </div>
  );
};
